//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Somos1V2IndicadorTipo2Card',
  props: {
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'count'
    },
    // 'count' | 'percent'
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    totalItem: {
      type: Object,
      default: null
    }
  },
  methods: {
    fechaLabel: function fechaLabel(item) {
      if (!item || !item.fecha) return '';
      var meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      var mes = meses[(item.fecha.month || 1) - 1] || '';
      return mes + ' ' + (item.fecha.year || '');
    },
    fmtCount: function fmtCount(v) {
      if (v === null || v === undefined) return '—';
      return Number(v).toLocaleString('es-PE');
    },
    fmtScore: function fmtScore(v) {
      if (v === null || v === undefined) return '—';
      return "".concat(v, "%");
    }
  }
};